import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3Icon, ActivityIcon, CreditCardIcon, RepeatIcon, FileTextIcon, DollarSignIcon, ShieldIcon, PieChartIcon, LayoutGridIcon } from 'lucide-react';
export function Reports() {
  const navigate = useNavigate();
  const reportSections = [{
    title: 'Track money movement',
    description: 'Understand the activity in your Maybank account, focused on how activity, fees, and payouts affect your balance.',
    reports: [{
      icon: BarChart3Icon,
      title: 'Balance summary',
      description: 'View your balance and activity summary',
      link: '/balance'
    }
    // Hidden: Activity
    // {
    //   icon: ActivityIcon,
    //   title: 'Activity',
    //   description: 'Track all account activity and transactions',
    //   link: null,
    // },
    // Hidden: Payment fees
    // {
    //   icon: CreditCardIcon,
    //   title: 'Payment fees',
    //   description: 'Analyze payment processing fees',
    //   link: null,
    // },
    // Hidden: Payout reconciliation
    // {
    //   icon: RepeatIcon,
    //   title: 'Payout reconciliation',
    //   description: 'Reconcile payouts with transactions',
    //   link: null,
    // },
    ]
  }, {
    title: 'Custom reports and data analysis',
    description: 'Build custom reports with SQL and AI-assisted natural language prompts.',
    reports: [{
      icon: FileTextIcon,
      title: 'Nadi custom reports',
      description: 'Create custom SQL reports with AI assistance',
      link: '/custom-metrics'
    }]
  }, {
    title: 'Payments analytics',
    description: 'Analyze key metrics and reports about your payments performance.',
    reports: [{
      icon: DollarSignIcon,
      title: 'Acceptance analytics',
      description: 'Track payment acceptance rates',
      link: '/payment-analytics?tab=acceptance'
    }, {
      icon: ShieldIcon,
      title: 'Authentication analytics',
      description: 'Monitor authentication success rates',
      link: '/payment-analytics?tab=authentication'
    }, {
      icon: FileTextIcon,
      title: 'Disputes analytics',
      description: 'Analyze dispute patterns and trends',
      link: '/payment-analytics?tab=disputes'
    }]
  }, {
    title: 'Operational reports',
    description: 'Analyze the operational effectiveness of your Maybank integration, across payments, fraud, and more.',
    reports: [{
      icon: LayoutGridIcon,
      title: 'Card monitoring programs',
      description: 'Track card program performance',
      link: '/card-monitoring'
    }
    // Hidden: Billing analytics
    // {
    //   icon: PieChartIcon,
    //   title: 'Billing analytics',
    //   description: 'Track billing and subscription metrics',
    //   link: null,
    // },
    ]
  }];
  return <div className="max-w-6xl mx-auto" data-id="element-8066">
      <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-8067">Reports</h1>

      <div className="space-y-12" data-id="element-8068">
        {reportSections.map((section, sectionIndex) => <div key={sectionIndex} data-id="element-8069">
            <div className="mb-6" data-id="element-8070">
              <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-8071">
                {section.title}
              </h2>
              <p className="text-sm text-gray-600 max-w-3xl" data-id="element-8072">
                {section.description}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-8073">
              {section.reports.map((report, reportIndex) => {
            const Icon = report.icon;
            return <button key={reportIndex} onClick={() => report.link && navigate(report.link)} className="flex items-start gap-3 p-4 bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-sm transition-all text-left group" data-id="element-8074">
                    <div className="flex-shrink-0 mt-0.5" data-id="element-8075">
                      <Icon size={20} className="text-gray-600 group-hover:text-blue-600 transition-colors" data-id="element-8076" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-8077">
                      <h3 className="text-sm font-medium text-gray-900 mb-1 group-hover:text-blue-600 transition-colors" data-id="element-8078">
                        {report.title}
                      </h3>
                      <p className="text-xs text-gray-600" data-id="element-8079">
                        {report.description}
                      </p>
                    </div>
                  </button>;
          })}
            </div>
          </div>)}
      </div>
    </div>;
}